/**
 * Ticker Speed Normalization
 * Sets animation duration based on content width so all tickers
 * scroll at the same perceived speed (pixels per second).
 */

const PX_PER_SECOND = 60;
const TRANSLATE_FRACTION = 1 / 3;

function setTickerDuration(el) {
  const distance = el.scrollWidth * TRANSLATE_FRACTION;
  const duration = distance / PX_PER_SECOND;
  el.style.animationDuration = `${duration}s`;
}

export function initTickerSpeed() {
  const tickers = document.querySelectorAll(
    '.c-ticker__scroll-wrapper, .c-ticker__logos'
  );

  tickers.forEach((el) => setTickerDuration(el));

  // Recalculate on resize (clamp values change wrapper widths)
  const observer = new ResizeObserver((entries) => {
    entries.forEach((entry) => setTickerDuration(entry.target));
  });

  tickers.forEach((el) => observer.observe(el));
}
